<template>
  <i-select :value="value" v-on="$listeners">
    <i-option
      v-for="(label, key) in groups"
      :key="key"
      :value="key"
      :label="label"
    />
  </i-select>
</template>

<script>
  export default {
    props: {
      value: {
        type: [String, Number],
        default: null
      }
    },

    computed: {
      groups: function() {
        return this.$t('mailer.stats.general.filter.group_by.values');
      }
    }
  };
</script>
